import React from "react";
import { Info } from "lucide-react";

const Disclaimer = ({ text, variant = "default" }) => {
  const colors =
    variant === "alert"
      ? "border-[#FF3B30]/40 bg-[#FF3B30]/5 text-red-200"
      : "border-white/10 bg-white/[0.03] text-white/65";
  return (
    <div className={`flex items-start gap-3 rounded-lg border ${colors} p-4 text-xs leading-relaxed`} data-testid="disclaimer">
      <Info className="h-4 w-4 mt-0.5 flex-shrink-0 opacity-80" />
      <span>{text}</span>
    </div>
  );
};

export default Disclaimer;
